import React from 'react';

export const FeatureToggleContext = React.createContext();

FeatureToggleContext.displayName = 'FeatureToggleContext';

export const FeatureToggleContextProvider = FeatureToggleContext.Provider;
export const FeatureToggleContextConsumer = FeatureToggleContext.Consumer;

export default FeatureToggleContext;
